export const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15MB
